<template>
    <ValidationObserver tag="form" ref="observer" @submit.prevent="submit()">
        <b-row class="row" v-if="!loading">
            <b-col cols="12">
                <FormInput label="Cantidad" type="text" name="cantidad" id="cantidad" rules="required" v-model="frecuencia.cantidad" />
            </b-col>
            <b-col cols="12">
                <label>Frecuencias</label>
                <ValidationProvider name="frecuencia" id="frecuencia" rules="required" v-slot="{ errors }">
                    <multiselect 
                        v-model="frecuencia.frecuencia"
                        id="frecuencia"
                        placeholder="Frecuencias"
                        :class="(errors[0] ? 'is-invalid' : '')"
                        :multiple="false" 
                        :options="frecuencias"
                    />
                    <span v-if="errors[0]" class="invalid-feedback mb-4 text-xs" style="width: 98%; display: block; background-color: red; color: white; padding: 2px;">{{ errors[0] }}</span>
                </ValidationProvider>
            </b-col>
            <b-col cols="12" class="text-right mt-3">
                <Button type="submit" name="button" :disabled="loading">GUARDAR</Button>
            </b-col>
        </b-row>
        <LoaderComponent v-else/>
    </ValidationObserver>
</template>

<script>
    export default {
        props: ['frecuencia'],
        data() {
            return {
                loading: false,
                frecuencias: ['Día/s', 'Semana/s', 'Mes/es']
            }
        },
        methods: {
            async submit() {
                const isValid = await this.$refs.observer.validate();
                if(isValid) {
                    this.guardar();
                }
            },
            guardar() {
                this.$emit('terminado');
            }
        }
    }
</script>
